"use strict";
exports["58fbb5ca"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizTeamsExternalCollabTitleText","description":"WizTeamsExternalCollabDesc","properties":{"oAuthCredential":{"type":"object","title":"TeamsUserOAuthCredentialsLabel"},"channelUrl":{"type":"string","title":"LabelSpecifyTeamOrChannelUrl","pattern":"^[hH][tT][tT][pP][sS]:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+([\\/?][a-zA-Z0-9\\/\\\\'?,=%$&#_.+-]*)?$"},"externalEmailAddress":{"type":"string","title":"LabelSpecifyMTRUPN","pattern":"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["oAuthCredential","channelUrl","externalEmailAddress","notice","proofOfWork"],"$id":"58fbb5ca"};
const pattern0 = new RegExp("^[hH][tT][tT][pP][sS]:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+([\\/?][a-zA-Z0-9\\/\\\\'?,=%$&#_.+-]*)?$", "u");
const pattern1 = new RegExp("^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="58fbb5ca" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.channelUrl === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "channelUrl"},message:"must have required property '"+"channelUrl"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.externalEmailAddress === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "externalEmailAddress"},message:"must have required property '"+"externalEmailAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.notice === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.proofOfWork === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.oAuthCredential !== undefined){
let data0 = data.oAuthCredential;
if(!(data0 && typeof data0 == "object" && !Array.isArray(data0))){
const err5 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.oAuthCredential.type,parentSchema:schema11.properties.oAuthCredential,data:data0};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.channelUrl !== undefined){
let data1 = data.channelUrl;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err6 = {instancePath:instancePath+"/channelUrl",schemaPath:"#/properties/channelUrl/pattern",keyword:"pattern",params:{pattern: "^[hH][tT][tT][pP][sS]:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+([\\/?][a-zA-Z0-9\\/\\\\'?,=%$&#_.+-]*)?$"},message:"must match pattern \""+"^[hH][tT][tT][pP][sS]:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+([\\/?][a-zA-Z0-9\\/\\\\'?,=%$&#_.+-]*)?$"+"\"",schema:"^[hH][tT][tT][pP][sS]:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+([\\/?][a-zA-Z0-9\\/\\\\'?,=%$&#_.+-]*)?$",parentSchema:schema11.properties.channelUrl,data:data1};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/channelUrl",schemaPath:"#/properties/channelUrl/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.channelUrl.type,parentSchema:schema11.properties.channelUrl,data:data1};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.externalEmailAddress !== undefined){
let data2 = data.externalEmailAddress;
if(typeof data2 === "string"){
if(!pattern1.test(data2)){
const err8 = {instancePath:instancePath+"/externalEmailAddress",schemaPath:"#/properties/externalEmailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"+"\"",schema:"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$",parentSchema:schema11.properties.externalEmailAddress,data:data2};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/externalEmailAddress",schemaPath:"#/properties/externalEmailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.externalEmailAddress.type,parentSchema:schema11.properties.externalEmailAddress,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.notice !== undefined){
let data3 = data.notice;
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.testAccountConsent === undefined){
const err10 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3.testAccountConsent !== undefined){
let data4 = data3.testAccountConsent;
if(typeof data4 !== "boolean"){
const err11 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data3};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data5 = data.proofOfWork;
if(typeof data5 !== "string"){
const err13 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data5};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}
